import styled from 'styled-components'

import { Span, StyledButton } from 'components/common/atoms'
import { COLOR } from 'styles/constants'

export const StyledImageButton = styled(StyledButton)`
  border-radius: 5px;
  border: 2px solid ${COLOR.WHITE};
  width: 98px;
  height: 63px;
  font-size: 12px;
  position: absolute;
  left: 10px;
  bottom: 10px;
`
export const StyledBackButton = styled(StyledButton)`
  border-radius: 17.5px;
  border: 1px solid ${COLOR.GREY_LV3};
  background-color: ${COLOR.GREY_LV6};
  width: 124px;
  height: 31px;
  font-size: 12px;
  padding: 8px 25px;
  position: absolute;
  z-index: 2;
  top: 10px;
  left: 10px;
  white-space: nowrap;
`

export const StyledStreetViewSpan = styled(Span)`
  color: ${COLOR.WHITE};
  font-size: 14px;
  position: absolute;
  z-index: 5;
  bottom: 8px;
  white-space: nowrap;
`
